import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State'; 
import { network } from 'src/api';
import { platform } from 'kts-platform-frame/api';
class ModulesAction extends ActionBasic<ModulesState> {
    public pageListCompany = async (pramas={}) => { 
        // let data = await network.userNetworkMyList(this, {  
        let data = await platform.networkCompanyList(this, {   // 等平台组件开通再调用
            ...pramas,
            // pageNum: 1, 
            // pageSize: 1000
        }); 
        if (data.er) {
            return;
        }    
        return data.res;
        // this.initSortList(data.res); 
    }
    public initSortList = (list) => {
        this.modulesState.list = list && list.map((item, index) => {
            return {
                ...item,
                index
            };
        }); 
        if (this.modulesState.listAll.length === 0) {
            this.modulesState.listAll = JSON.parse(JSON.stringify(this.modulesState.list)); // 初始化数据
        }
        let pageSortUserArray = this.pySegSort(list);  
        this.modulesState.pagination.total = list.length;
        this.modulesState.pagination.current = 1;  
        this.modulesState.sortList = pageSortUserArray;  
        this.setModulesState(this.modulesState);
    }
    /** 判断是否为中文 */
     public isChinese(temp: string)  
     {  
         var re=/[^\u4e00-\u9fa5]/;  
         if(re.test(temp)) {
             return false;  
         } else {
             return true;  
         }
     } 
    /** 判断是否为英文 */
     public isEnglish(temp: string)  
     {  
         var re=/[a-zA-Z]/;  
         if(re.test(temp)) {
             return false;  
         } else {
             return true;  
         }
     }  
    /** 汉字首字母按照字母分类，排序 */ 
     public pySegSort(arr: any[]) { 
        if(!String.prototype.localeCompare){  // String.prototype.localeCompare 比较中文汉字的排序
            return null;
        }  
        var letters = '*abcdefghjklmnopqrstwxyz'.split('');  // 按照字母分类
        var zh = '阿八嚓哒妸发旮哈讥咔垃痳拏噢妑七呥扨它穵夕丫帀'.split('');
         
        var segs = [];
        var curr;
        letters.forEach((item, i) => {
            curr = {letter: item, data:[]}; // 存储按照字母分类后的名字
            arr.forEach((jtem, j) => {
                let name = jtem;
                if ( typeof(jtem) === 'object') {
                    name = jtem.name || jtem.connectionName || '无';
                }    
                if (item.toUpperCase() === name.substr(0,1).toUpperCase())  { // 名字为英文时
                    curr.data.push(jtem);
                } else if( this.isChinese(name.substr(0,1)) && ((!zh[i-1] || zh[i-1].localeCompare(name,'zh') <= 0) && name.localeCompare(zh[i],'zh') === -1)) { // 名字为汉字时
                    curr.data.push(jtem);
                } else if ((!isNaN(name.substr(0,1))) && item === '*') { // 数字放在*中
                    curr.data.push(jtem); 
                }

            }); 
            if(curr.data.length) {
                segs.push(curr);
                curr.data.sort(function(a: any,b: any){
                    let aname = a.name || a.connectionName || '无';
                    let bname = b.name || b.connectionName || '无'; 
                    return aname.localeCompare(bname, 'zh');
                });
            }
        });
        return segs;
    } 
    /** 存储选中的数据 */
    public saveSelectData = (list=[]) => { 
        this.modulesState.selectRows = list;
        this.modulesState.indeterminate = !!list.length && (list.length < this.modulesState.list.length),
        this.modulesState.checkAll = list.length === this.modulesState.list.length,
        this.setModulesState();
    }

    /**
     *  
     * 将值转换为对象 
     * @param keyId: 公司唯一标识符
     * @param index: 对象角标
     * @param value: 传入字符串值
     * 
     */
    public valStringToObj = (keyId, index, value) => {
        if (typeof(value) !== 'string' && typeof(index) !== 'number') {
            return;
        }  
        var length = this.modulesState.list.length;   
        for(var i = 0; i < length; i++){  
            if(this.modulesState.list[i][keyId] === value)
            {   
                this.modulesState.selectRows[index] = this.modulesState.list[i];
                break;
            }
        }   
        this.saveSelectData(this.modulesState.selectRows);
    }
    /** 数组去重合并 */
    public concatEqual = (arr1, arr2) => {
        //不要直接使用let arr = arr1，这样arr只是arr1的一个引用，两者的修改会互相影响
        let arr = arr1.concat();
        //或者使用slice()复制，let arr = arr1.slice(0)
        for(let i=0; i<arr2.length; i++){ 
            arr.indexOf(arr2[i]) === -1 ? arr.push(arr2[i]) : 0;
        }  
        return arr;
    }
    /** 提交 */
    public setSubmit = () => {
        this.modulesState.submit = true;
        this.setModulesState();
    }
    /** 提交完成 */
    public cancelSubmit = () => {
        this.modulesState.submit = false;
        this.setModulesState();
    }
    /** 设置关键字 */
    public setKeywords = (keywords) => {
        this.modulesState.keywords = keywords;
        this.setModulesState();
    }
}

export default new ModulesAction();



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/part/CompanySelection/Modules.Action.ts